<script setup lang="ts" generic="T">
defineProps({
  options: null,
  label: { type: Function },
  enabled: { type: Function },
  menuWidth: null
})
const emit = defineEmits(["selected"])

function handleSelect(key: T) {
  emit("selected", key)
}
</script>

<template>
  <dropdown
    anchor-x="left"
    anchor-y="top"
    flow-x="right"
    flow-y="down"
  >
    <template #default="{ toggle }">
      <div @click="toggle()">
        <slot />
      </div>
    </template>
    <template #menu>
      <dropdown-menu
        class="inline-select-container"
        :style="{ width: menuWidth ? px(menuWidth) : undefined }"
      >
        <div class="inline-select-dropdown">
          <div
            v-for="option in options"
            :key="`${option}`"
            class="inline-select-option"
            @click="handleSelect(option as T)"
          >
            <div>{{ label(option as T) }}</div>
            <icon-action
              v-if="enabled(option as T)"
              size="xs"
              type="check"
              class="icon"
            />
            <div v-else class="icon" />
          </div>
        </div>
      </dropdown-menu>
    </template>
  </dropdown>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.inline-select-container
  @apply -ml-1 -mt-1
  
.inline-select-dropdown
  @apply flex flex-col gap-[#{$menu-gap-items}] px-[#{$menu-px-default}] py-[#{$menu-py-default}]

.inline-select-option
  @apply flex items-center
  @apply h-5 -m-1 p-1 gap-2
  @apply t-menu-sm text-[#{$global-t-default}]
  @apply rounded-[#{$menu-br-item}]
  @apply cursor-pointer
  &:hover
    @apply bg-[#{$menu-bg-item-hover}]
  .icon
    @apply ml-auto h-4 w-4
    @apply text-[#{$global-bg-icon-secondary}]
</style>
